var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CodeEditor',{attrs:{"btnLabel":_vm.$t('advancedFilters'),"libs":_vm.libs,"vars":_vm.vars,"snippets":_vm.snippets},model:{value:(_vm.content),callback:function ($$v) {_vm.content=$$v},expression:"content"}},[_c('b-btn',{attrs:{"variant":"success"},on:{"click":_vm.apply}},[_vm._v(_vm._s(_vm.$t('apply')))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }